import { Box, ScrollArea } from "@prismicio/editor-ui"
import type { ReactNode } from "react"
interface SidepaneContainerProps {
  children: ReactNode
  hasSelectedMedia: boolean
}

export function SidepaneContainer(props: SidepaneContainerProps) {
  const { children, hasSelectedMedia } = props

  return (
    <Box overflow="hidden" gridColumn="2 / -1" gridRow="1 / -1">
      <ScrollArea
        style={{
          display: "grid",
          height: "100%",
        }}
      >
        <Box
          flexGrow={1}
          borderRadius={{ topRight: 8, topLeft: 8 }}
          borderStyle={hasSelectedMedia ? "solid" : "dashed"}
          border={{ top: true, right: true, left: true, bottom: false }}
          minWidth={0}
        >
          {children}
        </Box>
      </ScrollArea>
    </Box>
  )
}
